import { render } from "./CustomFooter.vue?vue&type=template&id=4cd64713&scoped=true"
import script from "./CustomFooter.vue?vue&type=script&lang=js"
export * from "./CustomFooter.vue?vue&type=script&lang=js"

import "./CustomFooter.vue?vue&type=style&index=0&id=4cd64713&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd64713"]])

export default __exports__